// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Base card ── */
.ts-card {
  width: 100%;
  height: 100px;
  border-radius: 16px;
  border: 1.5px solid #e5e7eb;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  box-sizing: border-box;
  position: relative;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
  cursor: pointer;
  user-select: none;
}

.ts-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(33, 42, 55, 0.1);
}

/* ── State: available ── */
.ts-card--available {
  background-color: #ffffff;
  border-color: #e5e7eb;
}

/* ── State: created (newly occupied, no order yet) ── */
.ts-card--created {
  background-color: #ecfdf5;
  border-color: #a4f4cf;
}

.ts-card--created .ts-name         { color: #004f3b; }
.ts-card--created .ts-amount       { color: #004f3b; }
.ts-card--created .ts-status-label { color: #004f3b; }
.ts-card--created .ts-pax          { color: #004f3b; }
.ts-card--created .ts-time-badge--occupied { background-color: #daf5e4; color: #004f3b; }

/* ── State: occupied (order placed in kitchen) ── */
.ts-card--occupied {
  background-color: #ecfdf5;
  border-color: #a4f4cf;
}

.ts-card--occupied .ts-name         { color: #004f3b; }
.ts-card--occupied .ts-amount       { color: #004f3b; }
.ts-card--occupied .ts-status-label { color: #004f3b; }
.ts-card--occupied .ts-pax          { color: #004f3b; }

/* ── State: payment (ORDER_CREATED / PAYMENT_PENDING) ── */
.ts-card--payment {
  background-color: #fffbeb;
  border-color: #fee685;
}

.ts-card--payment .ts-name         { color: #7b3306; }
.ts-card--payment .ts-amount       { color: #7b3306; }
.ts-card--payment .ts-status-label { color: #7b3306; }
.ts-card--payment .ts-pax          { color: #7b3306; }

/* ── State: reserved — purple ── */
.ts-card--reserved {
  background-color: #faf5ff;
  border-color: #e9d5ff;
}

.ts-card--reserved .ts-name           { color: #7c3aed; }
.ts-card--reserved .ts-reserved-time  { color: #7c3aed; }
.ts-card--reserved .ts-reserved-label { color: #7c3aed; }
.ts-card--reserved .ts-pax            { color: #7c3aed; }
.ts-card--reserved .ts-seats-row      { color: #6b7280; }

/* ── Layout rows ── */
.ts-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
}

.ts-middle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 26px;
  flex-shrink: 0;
}

.ts-spacer { flex: 1; }

.ts-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
}

/* ── Typography ── */
.ts-name {
  font-size: 18px;
  font-weight: 700;
  color: #374151;
  line-height: 1;
}

.ts-amount {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  line-height: 1;
}

.ts-status-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1;
  color: #6b7280;
}

/* ── Time badge (pill) ── */
.ts-time-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 7px;
  line-height: 1;
  white-space: nowrap;
}

.ts-time-badge--occupied {
  background-color: #daf5e4;
  color: #004f3b;
}

.ts-time-badge--payment {
  background-color: #fdf2cc;
  color: #7b3306;
}

/* ── Reserved time (plain text) ── */
.ts-reserved-time {
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.ts-reserved-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1;
}

/* ── Person / pax ── */
.ts-pax {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
}

.ts-pax span {
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

/* ── Seats row (available / reserved) ── */
.ts-seats-row {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #9ca3af;
}

.ts-seats-row span {
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
}

/* ── Icon slot (placeholder so the amount stays left-aligned) ── */
.ts-icons-slot {
  width: 1px;
}

/* ── Action icon buttons (print / payment inside card) ── */
.ts-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: background-color 0.12s, opacity 0.12s;
  background: transparent;
  padding: 0;
}

.ts-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ts-icon-btn--occupied {
  color: #004f3b;
}

.ts-icon-btn--occupied:hover:not(:disabled) {
  background-color: #a4f4cf;
}

.ts-icon-btn--payment {
  color: #e17100;
}

.ts-icon-btn--payment:hover:not(:disabled) {
  background-color: #fee685;
}

/* ── Loader ── */
.ts-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .ts-card {
    height: 100px;
    padding: 9px 10px;
    border-radius: 10px;
  }

  .ts-name   { font-size: 13px; }
  .ts-amount { font-size: 12px; }
}

@media (max-width: 480px) {
  .ts-card {
    height: 92px;
    padding: 8px 9px;
    border-radius: 9px;
  }

  .ts-name   { font-size: 12px; }
  .ts-amount { font-size: 11px; }
  .ts-time-badge { font-size: 9px; padding: 2px 5px; }
}

/* ═══ DARK THEME — TableStructure cards ═══ */
.dark .ts-card {
  background-color: #1e293b;
  border-color: #334155;
}
.dark .ts-card:hover { box-shadow: 0 6px 16px rgba(0,0,0,0.3); }

.dark .ts-card--available { background-color: #1e293b; border-color: #334155; }

.dark .ts-card--created,
.dark .ts-card--occupied {
  background-color: #052e16;
  border-color: #14532d;
}
.dark .ts-card--created .ts-name,
.dark .ts-card--occupied .ts-name   { color: #6ee7b7; }
.dark .ts-card--created .ts-amount,
.dark .ts-card--occupied .ts-amount { color: #6ee7b7; }
.dark .ts-card--created .ts-status-label,
.dark .ts-card--occupied .ts-status-label { color: #34d399; }
.dark .ts-card--created .ts-pax,
.dark .ts-card--occupied .ts-pax    { color: #6ee7b7; }
.dark .ts-card--created .ts-time-badge--occupied { background-color: #14532d; color: #6ee7b7; }

.dark .ts-card--payment {
  background-color: #451a03;
  border-color: #78350f;
}
.dark .ts-card--payment .ts-name         { color: #fde68a; }
.dark .ts-card--payment .ts-amount       { color: #fde68a; }
.dark .ts-card--payment .ts-status-label { color: #fbbf24; }
.dark .ts-card--payment .ts-pax          { color: #fde68a; }

.dark .ts-card--reserved {
  background-color: #2e1065;
  border-color: #5b21b6;
}
.dark .ts-card--reserved .ts-name           { color: #c4b5fd; }
.dark .ts-card--reserved .ts-reserved-time  { color: #c4b5fd; }
.dark .ts-card--reserved .ts-reserved-label { color: #a78bfa; }
.dark .ts-card--reserved .ts-pax            { color: #c4b5fd; }
.dark .ts-card--reserved .ts-seats-row      { color: #64748b; }

.dark .ts-name         { color: #cbd5e1; }
.dark .ts-amount       { color: #f1f5f9; }
.dark .ts-status-label { color: #64748b; }
.dark .ts-pax          { color: #64748b; }
.dark .ts-seats-row    { color: #475569; }

.dark .ts-time-badge--occupied { background-color: #14532d; color: #6ee7b7; }
.dark .ts-time-badge--payment  { background-color: #78350f; color: #fde68a; }

.dark .ts-icon-btn--occupied:hover:not(:disabled) { background-color: #14532d; }
.dark .ts-icon-btn--payment:hover:not(:disabled)  { background-color: #78350f; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/TableStructure/TableStructure.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,6CAA6C,yBAAyB,EAAE,cAAc,EAAE;;AAExF,oDAAoD;AACpD;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;;AAEtD,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;;AAErD,mCAAmC;AACnC;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;;AAExD,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa,OAAO,EAAE;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iDAAiD;EACjD,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,aAAa,eAAe,EAAE;EAC9B,aAAa,eAAe,EAAE;AAChC;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,aAAa,eAAe,EAAE;EAC9B,aAAa,eAAe,EAAE;EAC9B,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACrD;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,uBAAuB,sCAAsC,EAAE;;AAE/D,4BAA4B,yBAAyB,EAAE,qBAAqB,EAAE;;AAE9E;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;sCACsC,cAAc,EAAE;AACtD;sCACsC,cAAc,EAAE;AACtD;4CAC4C,cAAc,EAAE;AAC5D;sCACsC,cAAc,EAAE;AACtD,mDAAmD,yBAAyB,EAAE,cAAc,EAAE;;AAE9F;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,2CAA2C,cAAc,EAAE;AAC3D,2CAA2C,cAAc,EAAE;AAC3D,2CAA2C,cAAc,EAAE;AAC3D,2CAA2C,cAAc,EAAE;;AAE3D;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;;AAE9D,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC,iCAAiC,yBAAyB,EAAE,cAAc,EAAE;AAC5E,iCAAiC,yBAAyB,EAAE,cAAc,EAAE;;AAE5E,oDAAoD,yBAAyB,EAAE;AAC/E,oDAAoD,yBAAyB,EAAE","sourcesContent":["/* ── Base card ── */\n.ts-card {\n  width: 100%;\n  height: 100px;\n  border-radius: 16px;\n  border: 1.5px solid #e5e7eb;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  position: relative;\n  transition: transform 0.12s ease, box-shadow 0.12s ease;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ts-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(33, 42, 55, 0.1);\n}\n\n/* ── State: available ── */\n.ts-card--available {\n  background-color: #ffffff;\n  border-color: #e5e7eb;\n}\n\n/* ── State: created (newly occupied, no order yet) ── */\n.ts-card--created {\n  background-color: #ecfdf5;\n  border-color: #a4f4cf;\n}\n\n.ts-card--created .ts-name         { color: #004f3b; }\n.ts-card--created .ts-amount       { color: #004f3b; }\n.ts-card--created .ts-status-label { color: #004f3b; }\n.ts-card--created .ts-pax          { color: #004f3b; }\n.ts-card--created .ts-time-badge--occupied { background-color: #daf5e4; color: #004f3b; }\n\n/* ── State: occupied (order placed in kitchen) ── */\n.ts-card--occupied {\n  background-color: #ecfdf5;\n  border-color: #a4f4cf;\n}\n\n.ts-card--occupied .ts-name         { color: #004f3b; }\n.ts-card--occupied .ts-amount       { color: #004f3b; }\n.ts-card--occupied .ts-status-label { color: #004f3b; }\n.ts-card--occupied .ts-pax          { color: #004f3b; }\n\n/* ── State: payment (ORDER_CREATED / PAYMENT_PENDING) ── */\n.ts-card--payment {\n  background-color: #fffbeb;\n  border-color: #fee685;\n}\n\n.ts-card--payment .ts-name         { color: #7b3306; }\n.ts-card--payment .ts-amount       { color: #7b3306; }\n.ts-card--payment .ts-status-label { color: #7b3306; }\n.ts-card--payment .ts-pax          { color: #7b3306; }\n\n/* ── State: reserved — purple ── */\n.ts-card--reserved {\n  background-color: #faf5ff;\n  border-color: #e9d5ff;\n}\n\n.ts-card--reserved .ts-name           { color: #7c3aed; }\n.ts-card--reserved .ts-reserved-time  { color: #7c3aed; }\n.ts-card--reserved .ts-reserved-label { color: #7c3aed; }\n.ts-card--reserved .ts-pax            { color: #7c3aed; }\n.ts-card--reserved .ts-seats-row      { color: #6b7280; }\n\n/* ── Layout rows ── */\n.ts-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.ts-middle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 26px;\n  flex-shrink: 0;\n}\n\n.ts-spacer { flex: 1; }\n\n.ts-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n/* ── Typography ── */\n.ts-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: #374151;\n  line-height: 1;\n}\n\n.ts-amount {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1;\n}\n\n.ts-status-label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  line-height: 1;\n  color: #6b7280;\n}\n\n/* ── Time badge (pill) ── */\n.ts-time-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 2px 7px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.ts-time-badge--occupied {\n  background-color: #daf5e4;\n  color: #004f3b;\n}\n\n.ts-time-badge--payment {\n  background-color: #fdf2cc;\n  color: #7b3306;\n}\n\n/* ── Reserved time (plain text) ── */\n.ts-reserved-time {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.ts-reserved-label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  line-height: 1;\n}\n\n/* ── Person / pax ── */\n.ts-pax {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #6b7280;\n}\n\n.ts-pax span {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n/* ── Seats row (available / reserved) ── */\n.ts-seats-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #9ca3af;\n}\n\n.ts-seats-row span {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n/* ── Icon slot (placeholder so the amount stays left-aligned) ── */\n.ts-icons-slot {\n  width: 1px;\n}\n\n/* ── Action icon buttons (print / payment inside card) ── */\n.ts-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.12s, opacity 0.12s;\n  background: transparent;\n  padding: 0;\n}\n\n.ts-icon-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ts-icon-btn--occupied {\n  color: #004f3b;\n}\n\n.ts-icon-btn--occupied:hover:not(:disabled) {\n  background-color: #a4f4cf;\n}\n\n.ts-icon-btn--payment {\n  color: #e17100;\n}\n\n.ts-icon-btn--payment:hover:not(:disabled) {\n  background-color: #fee685;\n}\n\n/* ── Loader ── */\n.ts-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .ts-card {\n    height: 100px;\n    padding: 9px 10px;\n    border-radius: 10px;\n  }\n\n  .ts-name   { font-size: 13px; }\n  .ts-amount { font-size: 12px; }\n}\n\n@media (max-width: 480px) {\n  .ts-card {\n    height: 92px;\n    padding: 8px 9px;\n    border-radius: 9px;\n  }\n\n  .ts-name   { font-size: 12px; }\n  .ts-amount { font-size: 11px; }\n  .ts-time-badge { font-size: 9px; padding: 2px 5px; }\n}\n\n/* ═══ DARK THEME — TableStructure cards ═══ */\n.dark .ts-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n.dark .ts-card:hover { box-shadow: 0 6px 16px rgba(0,0,0,0.3); }\n\n.dark .ts-card--available { background-color: #1e293b; border-color: #334155; }\n\n.dark .ts-card--created,\n.dark .ts-card--occupied {\n  background-color: #052e16;\n  border-color: #14532d;\n}\n.dark .ts-card--created .ts-name,\n.dark .ts-card--occupied .ts-name   { color: #6ee7b7; }\n.dark .ts-card--created .ts-amount,\n.dark .ts-card--occupied .ts-amount { color: #6ee7b7; }\n.dark .ts-card--created .ts-status-label,\n.dark .ts-card--occupied .ts-status-label { color: #34d399; }\n.dark .ts-card--created .ts-pax,\n.dark .ts-card--occupied .ts-pax    { color: #6ee7b7; }\n.dark .ts-card--created .ts-time-badge--occupied { background-color: #14532d; color: #6ee7b7; }\n\n.dark .ts-card--payment {\n  background-color: #451a03;\n  border-color: #78350f;\n}\n.dark .ts-card--payment .ts-name         { color: #fde68a; }\n.dark .ts-card--payment .ts-amount       { color: #fde68a; }\n.dark .ts-card--payment .ts-status-label { color: #fbbf24; }\n.dark .ts-card--payment .ts-pax          { color: #fde68a; }\n\n.dark .ts-card--reserved {\n  background-color: #2e1065;\n  border-color: #5b21b6;\n}\n.dark .ts-card--reserved .ts-name           { color: #c4b5fd; }\n.dark .ts-card--reserved .ts-reserved-time  { color: #c4b5fd; }\n.dark .ts-card--reserved .ts-reserved-label { color: #a78bfa; }\n.dark .ts-card--reserved .ts-pax            { color: #c4b5fd; }\n.dark .ts-card--reserved .ts-seats-row      { color: #64748b; }\n\n.dark .ts-name         { color: #cbd5e1; }\n.dark .ts-amount       { color: #f1f5f9; }\n.dark .ts-status-label { color: #64748b; }\n.dark .ts-pax          { color: #64748b; }\n.dark .ts-seats-row    { color: #475569; }\n\n.dark .ts-time-badge--occupied { background-color: #14532d; color: #6ee7b7; }\n.dark .ts-time-badge--payment  { background-color: #78350f; color: #fde68a; }\n\n.dark .ts-icon-btn--occupied:hover:not(:disabled) { background-color: #14532d; }\n.dark .ts-icon-btn--payment:hover:not(:disabled)  { background-color: #78350f; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
